import { remove as globalRemove, exists as globalExists } from 'utils/global';

/**
 * 
 * @param {*} id 
 */
export const awake = (id) => {
    var loaderId = getWaitDiv(id);
    if (globalExists(loaderId)) {
        globalRemove(loaderId);
    }
};

/**
 * 
 * @param {*} id 
 */
export const getWaitDiv = (id) => {
    return "wait_" + id;
};

/**
 * 
 * @param {*} id 
 * @param {*} funct 
 */
export const wait = (id, funct) => {
    var root 			= $('#'+id);
    var loaderId 		= getWaitDiv(id);
    var div				= '<div id="'+loaderId+'" class="loader" onclick="' +funct+ '"> </div>';
    root.prepend(div);
    $("#"+loaderId).hide();
    var rootHeight 		= root.outerHeight(true)*1;
    var cssMap 			= {
        "width"			: root.outerWidth(true),
        "height"		: rootHeight,
        "padding-top"	: rootHeight/2-(rootHeight/2),
        "background"	: "rgba(255,255,255,0.9)"
    };
    $("#"+loaderId).css(cssMap);
    document.getElementById(loaderId).style.zIndex = 50;
    $("#"+loaderId).show();

};

/**
 * 
 * @param {*} id 
 */
export const waitExists = (id) => {
    var loaderId = getWaitDiv(id);
    return globalExists(loaderId);
};


